import React from 'react';
import clsx from 'clsx';

import ModifyButton from 'components/atoms/Button/ModifyButton';

import './index.scss';

const PcConfOdItem = ({ text, children, modify, changeModifyMode }) => {
  return (
    <div className="PcConfOdItem">
      <span className="tagArea">
        <label className="tag">{text}</label>
      </span>
      <span className="items">
        {children}
      </span>
      <span className={clsx('modify-button-area', { hide: modify === false })}>
        <span className="">
          <ModifyButton onClick={changeModifyMode} />
        </span>
      </span>
    </div>
  );
};

export default PcConfOdItem;